import React from 'react';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { user, user_listUsers_data } from '@api/graphql/types';
import * as Queries from '@api/graphql/queries';

interface Prop {
    adminId: string;
}

interface State {
    user: user_listUsers_data;
}

class AdminOrder extends React.Component<Prop, State> {
    public componentDidMount() {
        const variables = {
            page: 1,
            count: 1,
            filters: {id: this.props.adminId},
        };

        GraphQLClient.query<user>({
            query: Queries.user,
            variables,
        }).then((response) => {
            if (response.data && response.data.listUsers) {
                const currentUser = response.data.listUsers.data[0];
                this.setState({ user: currentUser });
            }
        });
    }

    public render() {
        const name = (this.state && this.state.user) ? this.state.user!.name : this.props.adminId;
        if (this.state && this.state.user) {
            return (
                <p>Admin által feladva: <a href={`/users/admin/${this.props.adminId}`}>{name}</a></p>
            );
        }
        return null;
    }
}

export default AdminOrder;



// WEBPACK FOOTER //
// ./src/modules/Order/components/AdminOrder.tsx